import React, { Component } from "react";
import { Glyphicon, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import ScrollToTopOnMount from "../../../../../utils/scroll/ScrollToTopOnMount";
import { Timeline, TimelineItem } from "vertical-timeline-component-for-react";
import {
  formatDateTimeLog,
  formatDateSmallWithoutTimezone
} from "../../../../../utils/dates";
import NumberFormat from "react-number-format";

import styles from "./AdminProjectDetail.scss";

class AdminProjectDetail extends Component {
  getSuffix(type) {
    if (!type) return "";
    switch (type.toUpperCase()) {
      case "HOURLY":
        return "/hour";
      case "DAILY":
        return "/day";
      case "WEEKLY":
        return "/week";
      case "MONTHLY":
        return "/month";
      default:
        return "";
    }
  }

  getAdminName(admin) {
    return admin ? `${admin.first_name} ${admin.last_name}` : "-";
  }

  getStatusName(status) {
    return status ? status.display_name : "-";
  }

  isEmployer(roles) {
    let isEmployer = false;

    _.filter(roles, role => {
      if (role.name === "employer") {
        isEmployer = true;
      }
    });

    return isEmployer;
  }

  render() {
    const { projectData, projectFeed } = this.props;

    const NA = <div className={styles.naStyle}>N/A</div>;
    const bullet = <span className={styles.bullet}>&#9679;</span>;

    // Skills
    const skillsMapper = (skill, index) => (
      <li key={index}>{skill.description.name}</li>
    );

    const mustSkillsList =
      !_.isEmpty(projectData.must_skills) &&
      projectData.must_skills.map(skillsMapper);

    const mustSkillsListComponent = (
      <ul className={styles.list}>{mustSkillsList}</ul>
    );

    const niceSkillsList =
      !_.isEmpty(projectData.nice_skills) &&
      projectData.nice_skills.map(skillsMapper);

    const niceSkillsListComponent = (
      <ul className={styles.list}>{niceSkillsList}</ul>
    );

    // Feed
    const feedMapper = (feed, index) => (
      <TimelineItem
        key={index}
        dateText={formatDateTimeLog(feed.created_at)}
        dateInnerStyle={{ background: "#95cfb3" }}
      >
        <p className={styles.timelineItemUser}>
          {this.isEmployer(_.get(feed, "user.roles")) &&
          _.get(feed, "user.profile.company.name")
            ? _.get(feed, "user.profile.company.name")
            : _.get(feed, "user.full_name")
            ? _.get(feed, "user.full_name")
            : "System"}
        </p>
        <p>{feed.message}</p>
      </TimelineItem>
    );

    const feed = !_.isEmpty(projectFeed) && projectFeed.map(feedMapper);

    const feedComponent = (
      <Timeline className={styles.timeline} lineColor={"#ddd"}>
        {feed}
      </Timeline>
    );

    // Budget
    const formattedBudgetStart =
      formatDateSmallWithoutTimezone(projectData.budget_run_start) ==
      "Invalid date"
        ? "N/A"
        : formatDateSmallWithoutTimezone(projectData.budget_run_start);

    const formattedBudgetEnd =
      formatDateSmallWithoutTimezone(projectData.budget_run_end) ==
      "Invalid date"
        ? "N/A"
        : formatDateSmallWithoutTimezone(projectData.budget_run_end);

    let city = projectData.state
      ? `${projectData.city}, ${projectData.state}`
      : projectData.city;

    //remove 'USA' if the city string includes it
    if (projectData.city && projectData.city.includes(", USA")) {
      city = projectData.city.replace(", USA", "");
    }

    const dateField = () => {
      if (projectData.budget_run_start && projectData.budget_run_end) {
        return `${formattedBudgetStart} - ${formattedBudgetEnd}`;
      } else if (!projectData.budget_run_start && !projectData.budget_run_end) {
        return "Timing TBD";
      } else {
        if (projectData.budget_run_start) {
          return "Start Date: " + formattedBudgetStart;
        } else if (projectData.budget_run_end) {
          return "Project Due: " + formattedBudgetEnd;
        }
      }
    };

    let budgetRate = parseFloat(projectData.budget_rate_value);

    const budgetRateValue =
      _.get(projectData, "budget_type.value") === "Negotiable" ? (
        "Request from Member"
      ) : (
        <NumberFormat
          value={budgetRate}
          displayType={"text"}
          thousandSeparator={true}
          prefix={"$"}
          decimalScale={2}
        />
      );

    return (
      <div className={styles.reviewContainer}>
        <ScrollToTopOnMount />

        <div className={styles.projectReview}>
          <Row>
            <Col>
              <div className={styles.titleSection}>
                <h1> {projectData.title} </h1>
                <Link to={`/admin/project/${projectData.id}/edit`}>
                  <Glyphicon glyph="pencil" /> Edit
                </Link>
              </div>
              <div className={styles.companyTitle}>
                {_.get(projectData, "user.profile.company.name")}
              </div>
              <div className={styles.titleDescription}>
                {_.get(projectData, "user.first_name")}{" "}
                {_.get(projectData, "user.last_name")}
                &nbsp; ({_.get(projectData, "user.email")})
              </div>
              &nbsp;
            </Col>
          </Row>

          <Row>
            <div className={styles.divider} />
            <div className={styles.divider} />
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Admin</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              <div>{this.getAdminName(_.get(projectData, "admin"))}</div>
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Status</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              <div>{this.getStatusName(_.get(projectData, "status"))}</div>
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Summary</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              {_.get(projectData, "category.name")}
              {bullet}
              {city}
              {bullet}
              {dateField()}
              {bullet}
              {_.get(projectData, "budget_type.value") === "Negotiable" ? (
                "Request Fee from Member"
              ) : (
                <NumberFormat
                  value={budgetRate}
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={"$"}
                  decimalScale={2}
                  suffix={this.getSuffix(
                    _.get(projectData, "budget_type.value")
                  )}
                />
              )}
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Job Description</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              <h3 className={styles.subSectionHeader}>Overview</h3>
              <div>{ReactHtmlParser(projectData.overview)}</div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>
                Responsibilities + Deliverables
              </h3>
              <div>{ReactHtmlParser(projectData.responsibilities)}</div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Office location</h3>
              <div>{city}</div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Work from</h3>
              <div>
                {_.get(projectData, "work_type.value") === "Both"
                  ? "Remote and On Site"
                  : _.get(projectData, "work_type.value")}
              </div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Job Type</h3>
              <div>
                <p>{_.get(projectData, "job_type.value")}</p>
              </div>
              &nbsp;
              <div className={styles.divider} />
              <h3 className={styles.subSectionHeader}>Company Budget</h3>
              <div>
                <p>{_.get(projectData, "company_budget.value")}</p>
              </div>
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Budget</h2>
          </Row>
          <Row className={styles.whiteSection}>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Rate type</h3>
              <p>{_.get(projectData, "budget_type.value")}</p>
            </Col>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Rate</h3>
              <p>{budgetRateValue}</p>
            </Col>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Hours per Week</h3>
              <p>{projectData.budget_rate_period}</p>
            </Col>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Project Run</h2>
          </Row>
          <Row className={styles.whiteSection}>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>Start</h3>
              <p>{formattedBudgetStart || NA}</p>
            </Col>
            <Col xs={4}>
              <h3 className={styles.subSectionHeader}>End</h3>
              <p>{formattedBudgetEnd || NA}</p>
            </Col>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Skills</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              <div className={styles.skillsListContainer}>
                <h3 className={styles.subSectionHeader}>Must have skills</h3>
                {_.isEmpty(mustSkillsList) ? NA : mustSkillsListComponent}
              </div>

              <div className={styles.divider} />

              <div className={styles.skillsListContainer}>
                <h3 className={styles.subSectionHeader}>Nice-to-Have Skills</h3>
                {_.isEmpty(niceSkillsList) ? NA : niceSkillsListComponent}
              </div>
            </div>
          </Row>

          <Row className={styles.sectionHeader}>
            <h2 className={styles.headerText}>Feed</h2>
          </Row>
          <Row>
            <div className={styles.whiteSection}>
              {_.isEmpty(feed) ? NA : feedComponent}
            </div>
          </Row>
        </div>
      </div>
    );
  }
}

export default AdminProjectDetail;



// WEBPACK FOOTER //
// ./src/routes/admin/project/detail/components/AdminProjectDetail.js